import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, Award, Users, TrendingUp } from "lucide-react";

const WhoWeAre = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-sm font-semibold text-blue-600 uppercase tracking-wide mb-3">
            Who we Are
          </h2>
          <h3 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            An integrated commercial real estate firm providing investors and clients alike with a
            <span className="text-blue-600"> single source solution</span> for all their real estate needs.
          </h3>
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          <div className="aspect-square overflow-hidden rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300">
            <img
              src="https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=400"
              alt="Commercial Building 1"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="aspect-square overflow-hidden rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300">
            <img
              src="https://images.unsplash.com/photo-1587907536297-835157511d39?w=400"
              alt="Commercial Building 2"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="aspect-square overflow-hidden rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300">
            <img
              src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400"
              alt="Commercial Building 3"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="aspect-square overflow-hidden rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300">
            <img
              src="https://images.unsplash.com/photo-1448630360428-65456885c650?w=400"
              alt="Commercial Building 4"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Content */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Our regional market insight coupled with our deep roots in surrounding communities give us
              the ability to create solutions to complex projects, as well as help investors drive their
              real estate portfolio performance ultimately increasing their asset's performance and value.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              At KJP Properties, we inspire character and reinforce the element of community in our people
              and the industry. Our people are taught to lead with authenticity and integrity. This type of
              leadership is understood to attract others of similar qualities. We encourage a healthy
              work-life balance, teamwork, and enthusiasm which enhances the overall experience. Our family
              values rely on honesty and respect. This ideal is embedded into our commitment to our people
              and our clients.
            </p>
            <Button
              onClick={() => scrollToSection("contact")}
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105"
            >
              Learn More About Us
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </div>

          <div className="space-y-6">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl shadow-lg transform hover:scale-105 transition-all duration-300">
              <Award className="text-blue-600 mb-4" size={40} />
              <h4 className="text-xl font-bold text-gray-900 mb-2">Excellence in Service</h4>
              <p className="text-gray-700">
                Committed to delivering exceptional results and exceeding client expectations in every
                transaction.
              </p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl shadow-lg transform hover:scale-105 transition-all duration-300">
              <Users className="text-blue-600 mb-4" size={40} />
              <h4 className="text-xl font-bold text-gray-900 mb-2">Client-Focused Approach</h4>
              <p className="text-gray-700">
                Building lasting relationships through personalized service and comprehensive market
                expertise.
              </p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl shadow-lg transform hover:scale-105 transition-all duration-300">
              <TrendingUp className="text-blue-600 mb-4" size={40} />
              <h4 className="text-xl font-bold text-gray-900 mb-2">Proven Track Record</h4>
              <p className="text-gray-700">
                Years of successful deals and satisfied clients demonstrate our ability to deliver results.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;